// extracted by mini-css-extract-plugin
export var container = "image-card-module--container--+27s3";